'use strict';
/**
 * The message containing the request to create a WebRTC connexion
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MRequest =
/**
   * @param {string} temporaryId A temporary identifier during the socket
   * creation. The key will be changed to peerId when the connexion is
   * established successfully.
   * @param {string} peerId The identifier of the peer that will be reachable
   * through the socket being created. Null if it is yet to be known.
   * @param {string} protocolId The identifier of the protocol to route
   * messages.
   * @param {object} offer The WebRTC offer containing ways to establish a
   * direct peer-to-peer connexions. See WebRTC for more information.
   */
function MRequest(temporaryId, peerId, protocolId, offer) {
  var offerType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'init';

  _classCallCheck(this, MRequest);

  this.tid = temporaryId;
  this.peer = peerId;
  this.pid = protocolId;
  this.offer = offer;
  this.type = 'MRequest';
  this.offerType = offerType;
};

module.exports = MRequest;